import { useEffect, useState } from 'react';

import { compassLabel } from '../lib/format';

import { mapBridge } from './mapBridge';

export function CompassControl() {
  const [bearing, setBearing] = useState(0);

  useEffect(() => mapBridge.subscribeBearing(setBearing), []);

  const normalized = ((bearing % 360) + 360) % 360;
  const label = compassLabel(normalized);
  const offNorth = normalized > 0.5 && normalized < 359.5;

  return (
    <button
      type="button"
      onClick={() => mapBridge.resetNorth()}
      className={`flex aspect-square w-9 flex-col items-center justify-center rounded-lg bg-bg-panel/90 shadow ring-1 ring-bg-border backdrop-blur transition-opacity hover:bg-white/5 active:bg-white/10 ${
        offNorth ? 'opacity-100' : 'opacity-80'
      }`}
      aria-label={`Map bearing ${Math.round(normalized)}° ${label}. Tap to reset north.`}
      title={offNorth ? `Facing ${label} · tap for north` : 'North up'}
    >
      <div
        className="relative h-6 w-6"
        style={{ transform: `rotate(${-bearing}deg)` }}
        aria-hidden
      >
        <svg viewBox="0 0 24 24" className="h-6 w-6">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeOpacity="0.25" strokeWidth="1.5" />
          <path d="M12 4 L14 11 L12 9.5 L10 11 Z" fill="#f87171" />
          <path d="M12 20 L10 13 L12 14.5 L14 13 Z" fill="currentColor" fillOpacity="0.35" />
          <text x="12" y="7.5" textAnchor="middle" fontSize="5" fontWeight="700" fill="#f87171">
            N
          </text>
        </svg>
      </div>
      {offNorth ? (
        <span className="-mt-0.5 font-mono text-[9px] font-medium leading-none text-slate-300">{label}</span>
      ) : null}
    </button>
  );
}
